// App.js
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Form, Button, Modal } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { LoginSchema } from "../utils/validationSchema";
import axios from "axios";
import { serverPath } from "../config/keys";
import { toast } from "react-toastify";
import ResetPassword from "./resetPassword";
import Loader from "../components/loader/loader";
import { useUserContext } from "../context/userContext";

function LogIn({ setShowLogin, setShowRegister }) {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({ resolver: yupResolver(LoginSchema) });

  const { setUserLoggedIn } = useUserContext();

  const [showPassword, setShowPassword] = useState(false);

  const [showForgotModal, setShowForgotModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const registerUser = async (values) => {
    setLoading(true);
    try {
      const response = await axios.post(`${serverPath}/auth/login`, values);
      const {
        status,
        data: { message, token },
      } = response;
      if (status === 200) {
        localStorage.setItem("token", token);
        setShowLogin(false);
        setUserLoggedIn(true);
        toast.success(message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
        });
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.data) {
        toast.error(
          error?.response?.data?.message || "Internal server error!",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
          }
        );
        setLoading(false);
      }
    }
  };

  const handleNotAUser = () => {
    setShowRegister(true);
    setShowLogin(false);
  };

  const handleForgotModal = () => {
    setShowForgotModal(true);
    setShowLogin(false);
  };
  return (
    <div className="auth-wrapper">
      <div className="auth-container">
        <div class="login-cover">
          <img src="/Images/cat.png" className="cat-img" alt="" />
        </div>
        <div className="login-form">
          <div className="login-popup-content">
            <h2>Sign In</h2>

            <Form onSubmit={handleSubmit(registerUser)}>
              <Form.Group className="full-w">
                <Form.Control
                  className={`${errors?.email ? `error-border` : ``}`}
                  type="text"
                  name="email"
                  placeholder="Email Address"
                  {...register("email")}
                />
                {errors?.email ? (
                  <span className="error-msg">{errors.email.message}</span>
                ) : (
                  ""
                )}
              </Form.Group>

              <Form.Group className="full-w">
                <div className="pass-show password-input ">
                  <Form.Control
                    className={`${errors?.password ? `error-border` : ``}`}
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    name="password"
                    {...register("password")}
                  />
                  <span
                    className="eye-icon"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <EyeIcon /> : <EyesShut />}
                  </span>
                </div>

                {errors?.password ? (
                  <span className="error-msg">{errors.password.message}</span>
                ) : (
                  ""
                )}
              </Form.Group>
              <div className="  " style={{ cursor: "pointer" }}>
                <span
                  className="not-a-user-button bg-transparent border-0  cursor-pointer"
                  onClick={() => setShowForgotModal(true)}
                >
                  Forgot Password
                </span>
              </div>

              <div className="full-w">
                <Button className="auth-btn" type="submit">
                  {loading ? <Loader /> : "Login"}
                </Button>
              </div>
            </Form>

            <div className="d-flex justify-content-center mt-3">
              <button
                className="not-a-user-button bg-transparent border-0  cursor-pointer"
                onClick={handleNotAUser}
              >
                Not a user?
              </button>
            </div>
          </div>
        </div>
      </div>

      <Modal
        size="md"
        show={showForgotModal}
        onHide={handleForgotModal}
        centered
        className="auth-popup"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <ResetPassword setShowForgotModal={setShowForgotModal} />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default LogIn;

export const EyeIcon = () => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0007 12C15.0007 13.6569 13.6576 15 12.0007 15C10.3439 15 9.00073 13.6569 9.00073 12C9.00073 10.3431 10.3439 9 12.0007 9C13.6576 9 15.0007 10.3431 15.0007 12Z"
        stroke="#B94B36"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0012 5C7.52354 5 3.73326 7.94288 2.45898 12C3.73324 16.0571 7.52354 19 12.0012 19C16.4788 19 20.2691 16.0571 21.5434 12C20.2691 7.94291 16.4788 5 12.0012 5Z"
        stroke="#B94B36"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const EyesShut = () => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.99902 3L20.999 21M9.8433 9.91364C9.32066 10.4536 8.99902 11.1892 8.99902 12C8.99902 13.6569 10.3422 15 11.999 15C12.8215 15 13.5667 14.669 14.1086 14.133M6.49902 6.64715C4.59972 7.90034 3.15305 9.78394 2.45703 12C3.73128 16.0571 7.52159 19 11.9992 19C13.9881 19 15.8414 18.4194 17.3988 17.4184M10.999 5.04939C11.328 5.01673 11.6617 5 11.9992 5C16.4769 5 20.2672 7.94291 21.5414 12C21.2607 12.894 20.8577 13.7338 20.3522 14.5"
        stroke="#B94B36"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
